import { styled } from "../../../styles";

// Components
export const SurveysListTableContainer = styled("section", {
  position: "relative",
  height: "calc(100vh - 200px)",
  maxHeight: "800px",
  marginTop: "$5",
});

/**
 * The Workflows page's header actions, right-aligned on the title row. EN-5191: a flex row lets each
 * button size itself and the gap hold them apart, in any language.
 */
export const ListActions = styled("div", {
  display: "flex",
  gap: "$3",
  alignItems: "center",
  justifyContent: "flex-end",

  position: "absolute",
  right: "0",
  top: "-32px",
});

/** Workflows' "Add workflow" button. */
export const ActionButton = styled("button", {
  width: "fit-content",
  height: "26px",
  padding: "5px 11px",
  border: "none",
  borderRadius: "12px",
  backgroundColor: "$black",

  color: "$white",
  fontFamily: "$openSans",
  fontSize: "12px",
  fontWeight: "500",
  lineHeight: "16px",
  whiteSpace: "nowrap",
  cursor: "pointer",

  "&:hover": { backgroundColor: "$charcoal" },
  "&:focus-visible": {
    outline: "2px solid var(--colors-button-focus-border)",
  },
});

/** Filters the list by survey name or code; shaped like Workflows' hospital select. */
export const SearchBox = styled("label", {
  display: "flex",
  alignItems: "center",
  gap: "6px",
  width: "220px",
  height: "26px",
  padding: "0 10px",
  border: "1.5px solid $gray-70",
  borderRadius: "12px",
  backgroundColor: "$white",
  color: "$gray-80",

  "&:focus-within": { borderColor: "$charcoal" },

  input: {
    flex: 1,
    minWidth: 0,
    border: "none",
    outline: "none",
    background: "transparent",
    color: "$charcoal",
    fontFamily: "$openSans",
    fontSize: "12px",
    fontWeight: 500,

    "&::placeholder": { color: "$gray-80" },
  },
});
